// Definizione delle action types
export const SET_INFOGRAPHIC_LOADING = 'SET_INFOGRAPHIC_LOADING';
export const SET_INFOGRAPHIC_ERROR = 'SET_INFOGRAPHIC_ERROR';
export const SET_INFOGRAPHIC = 'SET_INFOGRAPHIC';
export const SET_ALL_INFOGRAPHICS = 'SET_ALL_INFOGRAPHICS';
export const CLEAR_CURRENT_INFOGRAPHIC = 'CLEAR_CURRENT_INFOGRAPHIC';
export const SET_INFOGRAPHIC_GENERATING_STEP = 'SET_INFOGRAPHIC_GENERATING_STEP';

// Action creators
export const setInfographicLoading = (isLoading) => ({
  type: SET_INFOGRAPHIC_LOADING,
  payload: isLoading
});

export const setInfographicError = (error) => ({
  type: SET_INFOGRAPHIC_ERROR,
  payload: error
});

export const setInfographic = (payload) => ({
  type: SET_INFOGRAPHIC,
  payload
});

export const setAllInfographics = (payload) => ({
  type: SET_ALL_INFOGRAPHICS,
  payload
});

export const clearCurrentInfographic = () => ({
  type: CLEAR_CURRENT_INFOGRAPHIC
});

export const setInfographicGeneratingStep = (step) => ({
  type: SET_INFOGRAPHIC_GENERATING_STEP,
  payload: step
});

// Stato iniziale
const initialState = {
  infographics: {},        // Cache ultima infografica per documento: { [documentId]: infographicData }
  allInfographics: {},     // Cache TUTTE le infografiche per documento: { [documentId]: [infographicData, ...] }
  currentInfographic: null,
  isLoading: false,
  error: null,
  generatingStep: null     // 'analyzing' | 'designing' | 'generating' | 'finalizing' | 'generating_X_of_Y'
};

// Reducer
const infographicReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INFOGRAPHIC_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        error: action.payload ? null : state.error // Clear error when starting to load
      };

    case SET_INFOGRAPHIC_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
        generatingStep: null
      };

    case SET_INFOGRAPHIC: {
      const { documentId, infographicData } = action.payload;
      return {
        ...state,
        infographics: documentId ? {
          ...state.infographics,
          [documentId]: infographicData
        } : state.infographics,
        currentInfographic: infographicData,
        isLoading: false,
        error: null,
        generatingStep: null
      };
    }

    case SET_ALL_INFOGRAPHICS: {
      const { documentId, infographics } = action.payload;
      return {
        ...state,
        allInfographics: documentId ? {
          ...state.allInfographics,
          [documentId]: infographics
        } : state.allInfographics
      };
    }

    case CLEAR_CURRENT_INFOGRAPHIC:
      return {
        ...state,
        currentInfographic: null,
        error: null,
        generatingStep: null
      };

    case SET_INFOGRAPHIC_GENERATING_STEP:
      return {
        ...state,
        generatingStep: action.payload
      };

    default:
      return state;
  }
};

export default infographicReducer;
